// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","description__header":"description__header-38VY5","toggle":"toggle-flazi","footer__inner":"footer__inner-3rh-7"};